import { Service } from "@warda/library-ui/interfaces";
import { BASE_URL } from "../constants/keys";
const apiUrls = {
    getLogoTenant: {
        url: (tenantId) => `${BASE_URL}/${Service.SC}/logo/${tenantId}`,
        method: "GET",
    },
};
export default apiUrls;
